import React, { useCallback } from 'react'
import { TransformData } from 'react-admin'
import { SaveWithConfirmButton } from './SaveWithConfirmButton'
import { SaveWithConfirmButtonProps } from './type'
import TaskAltIcon from '@mui/icons-material/TaskAlt'

const ApproveSaveButton: React.FC<SaveWithConfirmButtonProps> = ({
  encType = 'application/json',
  ...props
}) => {
  const transformApprove: TransformData = useCallback((data) => {
    return { ...data, is_approved: true }
  }, [])
  return (
    <SaveWithConfirmButton
      label='ra.action.save_and_approve'
      confirmTitle='ra.message.confirmation.approve.title'
      confirmContent='ra.message.confirmation.approve.content'
      alwaysEnable
      transform={transformApprove}
      icon={<TaskAltIcon />}
      type='button'
      encType={encType}
      {...props}
    />
  )
}

export default ApproveSaveButton
